import { render, staticRenderFns } from "./SushiDiaoxianItemZhixi.vue?vue&type=template&id=7540501c&scoped=true&"
import script from "./SushiDiaoxianItemZhixi.vue?vue&type=script&lang=js&"
export * from "./SushiDiaoxianItemZhixi.vue?vue&type=script&lang=js&"
import style0 from "./SushiDiaoxianItemZhixi.vue?vue&type=style&index=0&id=7540501c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7540501c",
  null
  
)

export default component.exports